import React, { useEffect, useState } from 'react';
import EventsFilter from './eventsFilter';

// import PageTitle from '../../components/PageTitle';
import PageTitle from '../../../components/PageTitle';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FeatherIcon from 'react-feather';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import {
    list_News,
    update_News,
    new_News,
    delete_News,
    list_Internship,
    new_Internship,
    update_Internship,
    delete_Internship,
} from '../../../helpers/actions/api.functions';
import FilterButton from '../../../components/FilterButton';
import AddEvents from './addInternship';
import Swal from 'sweetalert2';
import moment from 'moment';

const AdminInternshipList = () => {
    const [data, setData] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [editData, setEditData] = useState({});
    const [modal, setModal] = useState(false);
    const [modalb, setModalb] = useState(false);
    const [edit, setEdit] = useState(false);
    const [key, updateKey] = useState(0);

    const [stateActive, setStateActive] = useState('true');
    const getNews = () => {
        setIsActive(true);
        list_Internship()
            .then((res) => {
                setIsActive(false);
                setData(res.data);
                // setData(res.result);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response.data.message);
            });
    };
    const openedit = (row) => {
        setEdit(true);
        console.log(row);
        setEditData({
            id: row?.id,
            description: row?.description,
            title: row?.title,
            end_date: row?.end_date ? moment(row.end_date).format('YYYY-MM-DD') : '',
            organisation: row?.organisation,
            status: row?.status,
        });
        setModalb(true);
    };

    const defaultSorted = [
        {
            dataField: 'id',
            order: 'desc',
        },
    ];
    const toggle = () => {
        setModal(false);
    };
    const toggleb = () => {
        setModalb(false);

        setEdit(false);
        setEditData({});
    };
    // console.log(data.length);
    const handleSubmitNews = (formdata) => {
        setIsActive(true);

        if (edit) {
            update_Internship(formdata.id, formdata) // send FormData
                .then((res) => {
                    setIsActive(false);
                    toast.success(res.message);
                    getNews();
                    setModalb(false);
                    setEditData({});
                    setEdit(false);
                })
                .catch((err) => {
                    setIsActive(false);
                    console.error('Update error:', err.response?.data);
                    toast.error(err.response?.data?.message || 'Update failed');
                });
        } else {
            new_Internship(formdata) // send FormData
                .then((res) => {
                    setIsActive(false);
                    toast.success(res.message);
                    getNews();
                    setModalb(false);
                    setEditData({});
                    setEdit(false);
                })
                .catch((err) => {
                    setIsActive(false);
                    console.error('Creation error:', err.response?.data);
                    toast.error(err.response?.data?.message || 'Creation failed');
                });
        }
    };

    const handleDelete = (d) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                delete_Internship(d)
                    .then((res) => {
                        setIsActive(false);
                        toast.success(res.message);
                        getNews();
                        console.log(res);
                        setModalb(false);
                        setEditData({});
                        setEdit(false);
                    })
                    .catch((err) => {
                        setIsActive(false);
                        toast.error(err.response.message);
                    });
            }
        });
    };

    const columns = [
        {
            dataField: 'title',
            text: 'Title',
            sort: true,
        },
        {
            dataField: 'end_date',
            text: 'Date',
            sort: true,
            formatter: (rowContent) => {
                return (
                    <div className="text-capitalize">
                        {rowContent ? moment(rowContent).format('DD-MMM-YYYY') : '--'}
                    </div>
                );
            },
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: (rowContent) => {
                return (
                    <div
                        className={`badge ${
                            rowContent === 'active'
                                ? 'badge-soft-success'
                                : rowContent === 'inactive'
                                ? 'badge-soft-danger'
                                : ''
                        }`}>
                        {rowContent}
                    </div>
                );
            },
        },
        {
            dataField: 'id',
            text: 'Action',
            sort: false,
            formatter: (rowContent, row) => {
                return (
                    <div className="d-flex">
                        <div>
                            <Link to={`/Internship-detail/${rowContent}`}>
                                <FeatherIcon.Eye className="icon-action view-ico" />
                            </Link>
                        </div>
                        <div onClick={() => openedit(row)}>
                            <FeatherIcon.Edit3 className="icon-action view-ico mx-2" />
                        </div>
                        <div onClick={() => handleDelete(rowContent)}>
                            <FeatherIcon.Trash className="icon-action delete-ico" />
                        </div>
                    </div>
                );
            },
        },
    ];

    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
        <React.Fragment>
            <label className="d-inline mr-1">Show</label>
            <Input
                type="select"
                name="select"
                id="no-entries"
                className="custom-select custom-select-sm d-inline col-1 pl-1"
                value={currSizePerPage}
                onChange={(e) => onSizePerPageChange(e.target.value)}>
                {options.map((option, idx) => {
                    {
                        console.log(typeof currSizePerPage);
                    }
                    return (
                        <option key={idx} value={option.page}>
                            {option.text}
                        </option>
                    );
                })}
            </Input>
            <label className="d-inline ml-1">entries</label>
        </React.Fragment>
    );
    const { SearchBar } = Search;

    useEffect(() => {
        getNews();
    }, []);
    if (isActive) {
        return <PreloaderWidget />;
    }
    // console.log(show);
    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[{ label: 'Internship', path: '/internship-list', active: true }]}
                        title={'Internship '}
                    />
                </Col>
            </Row>
            <Row>
                <Card className="w-100">
                    <CardBody>
                        <ToolkitProvider
                            bootstrap4
                            keyField="id"
                            data={data}
                            columns={columns}
                            search
                            exportCSV={{ onlyExportFiltered: true, exportAll: false }}>
                            {(props) => (
                                <React.Fragment>
                                    <Row className="mb-2">
                                        <Col className="text-left">
                                            <FilterButton
                                                onClick={() => {
                                                    console.log('fb');
                                                    setModalb(!modalb);
                                                }}
                                                btnname="Add Internship"
                                                className="filterbtn ml-0"
                                            />
                                        </Col>
                                        {/* <Col className="text-right">
                                            <ExportCSVButton {...props.csvProps} className="btn btn-primary">
                                                Export CSV
                                            </ExportCSVButton>
                                            <FilterButton
                                                onClick={() => {
                                                    console.log('fb');
                                                    setModal(!modal);
                                                }}
                                                btnname="Filter"
                                                className="filterbtn mr-0"
                                            />
                                        </Col> */}
                                    </Row>

                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={true}
                                        defaultSorted={defaultSorted}
                                        pagination={paginationFactory({
                                            sizePerPage: 5,
                                            sizePerPageRenderer: sizePerPageRenderer,
                                            sizePerPageList: [
                                                { text: '5', value: 5 },
                                                { text: '10', value: 10 },
                                                { text: '25', value: 25 },
                                                { text: 'All', value: data.length },
                                            ],
                                        })}
                                        wrapperClasses="table-responsive"
                                    />
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </CardBody>
                </Card>
            </Row>
            {/* /////////////////////////////////////////////////// */}
            {modal && <EventsFilter open={modal} handleClose={toggle} handleApply={toggle} />}
            {modalb && (
                <AddEvents
                    open={modalb}
                    handleClose={toggleb}
                    handleApply={handleSubmitNews}
                    data={editData}
                    edit={edit}
                />
            )}
        </React.Fragment>
    );
};

export default AdminInternshipList;
